import './list.css';
export default {
  "list": "pf-v6-c-list",
  "listItem": "pf-v6-c-list__item",
  "listItemIcon": "pf-v6-c-list__item-icon",
  "modifiers": {
    "iconLg": "pf-m-icon-lg",
    "plain": "pf-m-plain",
    "inline": "pf-m-inline",
    "bordered": "pf-m-bordered"
  }
};